import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import Button from '../../Button'

import * as styles from './FilePreviewDeleteButton.module.css'

import DeleteIcon from '../../../icons/delete.svg'

function FilePreviewDeleteButton({ className, qaName, onClick }) {
  const { t } = useTranslation()

  const deleteButtonClassName = classnames(styles.deleteButton, className)

  return (
    <Button.Outlined
      isGrey
      beforeIconProps={{ Icon: DeleteIcon }}
      className={deleteButtonClassName}
      qaName={qaName}
      tooltip={t('Files.PreviewDeleteButtonTooltipTextKey')}
      onClick={onClick}
    />
  )
}

export default FilePreviewDeleteButton
